import { environment } from './../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { UsuarioEntry } from 'src/app/shared/entrys/usuario.entry';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { retry, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PrestadorEntry } from 'src/app/shared/entrys/prestador.entry';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class RegistroCuentaService implements RequestCRUD<PrestadorEntry, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
		this.handleError = httpErrorHandler.createHandleError('RegistroCuentaService');
	}

	get(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Prestador/ValidarIdentidad`, entry).pipe(
			// retry(2)
		);
	}

	update(entry: PrestadorEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	create(entry: PrestadorEntry): Observable<ResponseServiceModel> {
		// if (!environment.production) {
		// 	entry.correo_electronico = 'harrisson.zapata@olsoftware.com'; // FIXME: Borrar
		// }
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/prestador/crear`, entry).pipe(
			retry(2)
		);
	}
	delete(entry: PrestadorEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	reenviar(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/usuario/ReenviarCorreo`, entry).pipe(
			retry(2));
	}

	getParametro(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Parametro/DetallePorId`, entry).pipe(
			retry(2)
		);
	}
}
